import { observable, action, makeObservable } from 'mobx';

class RouterStore {
  history = null;

  location = null;

  constructor() {
    makeObservable(this, {
      history: observable,
      location: observable,
      updateLocation: action,
      push: action,
      replace: action,
      go: action,
      goBack: action,
      goForward: action,
    });
  }

  updateLocation(newState) {
    this.location = newState;
  }

  push = (location, state) => {
    this.history.push(location, state);
  };

  replace = (location, state) => {
    this.history.replace(location, state);
  };

  go = (n) => {
    this.history.go(n);
  };

  goBack = () => {
    this.history.goBack();
  };

  goForward = () => {
    this.history.goForward();
  };
}

const routerStore = new RouterStore();

export default routerStore;
